import { useTranslation } from 'react-i18next'

import limitedTime from '../../assets/limited-time.svg'
import { OgramModal } from '../../../../components/ogram-modal/ogram-modal'
import './auto-confirmation-modal.scss'

interface AutoConfirmationModalProps {
  modalIsOpen: boolean
  closeModal: () => void
}

const AutoConfirmationModal = ({ closeModal, modalIsOpen }: AutoConfirmationModalProps) => {
  const { t } = useTranslation()

  return (
    <OgramModal modalVisible={modalIsOpen} className="AutoConfirmationModal" onClose={closeModal}>
      <img src={limitedTime} />
      <h2 className="AutoConfirmationModal__modalTitle">{t('shift_attendance_common.limited_time_to_confirm')}</h2>
      <p>{t('shift_attendance_common.time_to_review_description')}</p>
      <button onClick={closeModal} className="AutoConfirmationModal__closeButton">
        {t('shift_attendance_common.i_understand')}
      </button>
    </OgramModal>
  )
}

export default AutoConfirmationModal
